import { createContext, useContext, useEffect, useMemo, useState } from "react";

const CartContext = createContext(null);
const KEY = "bs_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [coupon, setCoupon] = useState(() => localStorage.getItem("bs_coupon") || "");

  useEffect(() => localStorage.setItem(KEY, JSON.stringify(items)), [items]);
  useEffect(() => localStorage.setItem("bs_coupon", coupon), [coupon]);

  const add = (book, format, qty = 1) => {
    setItems((prev) => {
      const idx = prev.findIndex((i) => i.book_id === book.book_id && i.format === format);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], qty: format === "ebook" ? 1 : next[idx].qty + qty };
        return next;
      }
      const price = { ebook: book.ebook_price, hardcover: book.hardcover_price, physical: book.physical_price }[format];
      return [...prev, {
        book_id: book.book_id, title: book.title, slug: book.slug, cover_url: book.cover_url, format,
        qty: format === "ebook" ? 1 : qty, unit_price: price,
        stock: format === "hardcover" ? book.hardcover_stock : book.stock,
      }];
    });
  };
  const update = (book_id, format, qty) =>
    setItems((prev) => prev.map((i) => (i.book_id === book_id && i.format === format ? { ...i, qty: Math.max(1, qty) } : i)));
  const remove = (book_id, format) => setItems((prev) => prev.filter((i) => !(i.book_id === book_id && i.format === format)));
  const clear = () => { setItems([]); setCoupon(""); };

  const count = useMemo(() => items.reduce((n, i) => n + i.qty, 0), [items]);
  const subtotal = useMemo(() => items.reduce((n, i) => n + i.qty * i.unit_price, 0), [items]);

  return (
    <CartContext.Provider value={{ items, add, update, remove, clear, count, subtotal, coupon, setCoupon }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
